var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");

var HoleInteractionView = require("./holeInteractionView.js");
var HoleInteractionModel = require("./holeInteractionModel.js");

var HoleViewerController = function(archLayers, dependencies, configuration) {
    editor_2d.AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(HoleViewerController, editor_2d.AbstractViewerController);
HoleViewerController.inject = lib_core.clone(editor_2d.AbstractViewerController.inject);

module.exports = HoleViewerController;

HoleViewerController.prototype.getDataType = function () {
    return cio_datamodel.HoleData;
};

HoleViewerController.prototype.getInteractionViewType = function () {
    return HoleInteractionView;
};

HoleViewerController.prototype.getInteractionModelType = function () {
    return HoleInteractionModel;
};
